/** biome-ignore-all lint/correctness/useExhaustiveDependencies: prevent infinite loop */
import { Location } from '@cobliteam/common-types';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { dashboardClient } from '../index';

const PrismicPreviewPage = () => {
  const history = useHistory();

  useEffect(() => {
    dashboardClient
      .resolvePreviewURL({
        defaultURL: '/',
        linkResolver: (doc) => {
          if (doc.type === 'news_page') return Location.NEWS;
          return '/';
        },
      })
      .then(history.push);
  }, []);

  return <div>Redirecionando...</div>;
};

export default PrismicPreviewPage;
